import { useEffect } from "react";
import { SITE } from "../seo";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Full SEO hook: title, description, keywords, canonical, OG, Twitter, JSON-LD.
export default function useSEO({ title, description, keywords, path, image, jsonLd } = {}) {
  useEffect(() => {
    if (title) document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("name", "keywords", Array.isArray(keywords) ? keywords.join(", ") : keywords);

    const canonical = path ? `${SITE.url}${path}` : undefined;
    upsertLink("canonical", canonical);

    const ogImg = image ? (image.startsWith("http") ? image : `${SITE.url}${image}`) : `${SITE.url}${SITE.ogImage}`;
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:site_name", SITE.name);
    if (canonical) upsertMeta("property", "og:url", canonical);
    upsertMeta("property", "og:image", ogImg);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", ogImg);

    // JSON-LD structured data
    const id = "seo-jsonld";
    let script = document.getElementById(id);
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = id;
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
  }, [title, description, keywords, path, image, jsonLd]);
}
